import "@hotwired/turbo-rails"
import "tinymce/tinymce.min.js";
import "./packs/tinymcepack";
import { DateTime } from "luxon";
import { Tooltip, Popover } from 'bootstrap'

import "tinymce/plugins/emoticons";
import "tinymce/plugins/emoticons/js/emojis";
import "tinymce/themes/silver/theme";
import "tinymce/models/dom/model";
import "tinymce/icons/default/icons";
import "tinymce/plugins/wordcount";

// Skins und Content CSS importieren
import 'tinymce/skins/ui/oxide/skin';
import 'tinymce/skins/ui/oxide/content';
import 'tinymce/skins/content/default/content';

import "./controllers"

// After turbo loads the toggle doesn't work on some popovers and tooltips, maybe even for
// other boostrap elements, so this might need additional things.
// THIS WILL BREAK OTHER JS STUFF! SO THIS NEEDS TO HAPPEN SOMEWHERE ELSE OR WE NEED TO FIGURE
// OUT WHY THIS BREAKS DROP DOWN MENUS AND OTHER THINGS.. MAYBE WE DOUBLED POPOVER/TOOLTIPS
// AND THIS BREAKS IT?
//
// 2025-04-21: This seems to work fine now. I don't know why it didn't work before.
document.addEventListener('turbo:load', () => {
    for (const popoverElement of document.querySelectorAll("[data-bs-toggle=popover]")) {
      const popover = new Popover(popoverElement);
      popover.enable();
    }
    for (const tooltipElement of document.querySelectorAll("[data-bs-toggle=tooltip]")) {
      const tooltip = new Tooltip(tooltipElement);
      tooltip.enable();
    }

    // This is for the session timeout controller
    if (globalThis.sessionTimeoutTimer) {
        globalThis.sessionTimeoutTimer.forEach((timer) => {
            timer.reset();
        });
    }
});

document.addEventListener('turbo:before-stream-render', () => {
    // This is for the session timeout controller
    if (globalThis.sessionTimeoutTimer) {
        globalThis.sessionTimeoutTimer.forEach((timer) => {
            timer.reset();
        });
    }
});

function formatDate(date) {
    return DateTime.fromISO(date).toLocaleString(DateTime.DATE_SHORT);
}

window.formatDate = formatDate;
